export default __webpack_public_path__ + "static/media/island4.2410f9dd.jpg";